<template>
  <div class="dataV">
    <ScaleBox
      :width="1920"
      :height="1080"
      bgc="transparent"
      :delay="100"
      :isFlat="false"
    >
      <div class="dataV-main">
        <div class="dataV-header">
          <div class="dataV-header-btns">
            <el-button @click="goToHome" icon="el-icon-house">Home</el-button>
            <el-button @click="openDrawer" icon="el-icon-menu"
              >打开功能菜单</el-button
            >
          </div>
          <div class="dataV-header-left">
            <div class="dataV-header-time-sys">系统时间：{{ sysdate }}</div>
          </div>
          <div class="dataV-header-tit">
            <img src="@/assets/dataV/blue/tit.png" alt="" />
          </div>

          <div class="dataV-header-time-data">数据时间：{{ dateTime }}</div>
        </div>
        <div class="dataV-body">
          <div class="dataV-body-l">
            <div class="dataV-body-l-t">
              <div class="dataV-tit">
                <img src="@/assets/dataV/blue/tit1.png" alt="" />
              </div>
              <div class="dataV-body-l-part1">
                <dl v-for="item in projectTotal" :key="item.id">
                  <dt v-if="item.reportChartCode == 'projectNum'">
                    <img src="@/assets/dataV/blue/pic1.png" alt="" />
                  </dt>
                  <dd v-if="item.reportChartCode == 'projectNum'">
                    <h2>{{ item.reportChartValue }}</h2>
                    <h3>存续项目</h3>
                  </dd>
                  <dt v-if="item.reportChartCode == 'orderNum'">
                    <img src="@/assets/dataV/blue/pic2.png" alt="" />
                  </dt>
                  <dd v-if="item.reportChartCode == 'orderNum'">
                    <h2>{{ item.reportChartValue }}</h2>
                    <h3>工单</h3>
                  </dd>

                  <dt v-if="item.reportChartCode == 'taskNum'">
                    <img src="@/assets/dataV/blue/pic3.png" alt="" />
                  </dt>
                  <dd v-if="item.reportChartCode == 'taskNum'">
                    <h2>{{ item.reportChartValue }}</h2>
                    <h3>分配任务</h3>
                  </dd>

                  <dt v-if="item.reportChartCode == 'employeeItemNum'">
                    <img src="@/assets/dataV/blue/pic4.png" alt="" />
                  </dt>
                  <dd v-if="item.reportChartCode == 'employeeItemNum'">
                    <h2>{{ item.reportChartValue }}</h2>
                    <h3>出勤人次</h3>
                  </dd>
                </dl>
              </div>
              <div class="dataV-body-l-tit">各项目完成率排名</div>
              <div class="dataV-body-l-part2">
                <dl v-for="(item, index) in projectRate" :key="item.id">
                  <dt>
                    <el-progress
                      type="circle"
                      :show-text="false"
                      :percentage="
                        item.reportChartValue < 1
                          ? parseFloat(
                              $math.format(
                                $math.multiply(
                                  $math.bignumber(item.reportChartValue),
                                  100,
                                ),
                              ),
                            )
                          : 100
                      "
                      :width="50"
                      :color="projectRateColor[index][0]"
                      :define-back-color="projectRateColor[index][1]"
                      :stroke-width="10"
                      stroke-linecap="square"
                    ></el-progress>
                  </dt>
                  <dd>
                    <h2 :style="{ color: projectRateColor[index][0] }">
                      {{
                        $math.format(
                          $math.multiply(
                            $math.bignumber(item.reportChartValue),
                            100,
                          ),
                        )
                      }}%
                    </h2>
                    <h3>{{ item.reportChartCode }}</h3>
                  </dd>
                </dl>
              </div>
              <div class="dataV-body-l-tit">收到工单时间点分布</div>
              <div class="dataV-body-l-part3">
                <lineChart
                  v-if="workXdata.length > 0"
                  :xData="workXdata"
                  :yData="workYdata"
                ></lineChart>
              </div>
              <div class="dataV-body-l-tit">各类任务占比</div>
              <div class="dataV-body-l-part4">
                <div class="dataV-proportion">
                  <dl
                    :style="{ width: item.percent + '%' }"
                    v-for="item in taskWorkItem"
                    :key="item.id"
                  >
                    <dt>{{ item.percent }}%</dt>
                    <dd>{{ item.reportChartValue }}</dd>
                  </dl>
                </div>
                <div class="dataV-proportion-tooltip">
                  <ul>
                    <li v-for="item in taskWorkItem" :key="item.id">
                      <i></i>{{ item.reportChartCode }}
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div class="dataV-body-l-b">
              <div class="dataV-tit">
                <img src="@/assets/dataV/blue/tit2.png" alt="" />
              </div>
              <div class="dataV-body-l-b-box">
                <calendarChart
                  v-if="carData.length > 0"
                  :carData="carData"
                ></calendarChart>
              </div>
            </div>
          </div>
          <div class="dataV-body-m">
            <div class="dataV-body-m-t">
              <dl v-for="item in townTotal" :key="item.id">
                <dt v-if="item.reportChartCode == 'jdNum'">
                  <img src="@/assets/dataV/blue/pic5.png" alt="" />
                </dt>
                <dd v-if="item.reportChartCode == 'jdNum'">
                  <h2>服务街镇</h2>
                  <h3>
                    <span>{{ item.reportChartValue }}</span
                    >个
                  </h3>
                </dd>
                <dt v-if="item.reportChartCode == 'RoadNum'">
                  <img src="@/assets/dataV/blue/pic6.png" alt="" />
                </dt>
                <dd v-if="item.reportChartCode == 'RoadNum'">
                  <h2>覆盖道路</h2>
                  <h3>
                    <span>{{ item.reportChartValue }}</span
                    >条
                  </h3>
                </dd>
                <dt v-if="item.reportChartCode == 'taskNum'">
                  <img src="@/assets/dataV/blue/pic7.png" alt="" />
                </dt>
                <dd v-if="item.reportChartCode == 'taskNum'">
                  <h2>抢修</h2>
                  <h3>
                    <span>{{ item.reportChartValue }}</span
                    >处
                  </h3>
                </dd>
                <dt v-if="item.reportChartCode == 'pipeLineNum'">
                  <img src="@/assets/dataV/blue/pic8.png" alt="" />
                </dt>
                <dd v-if="item.reportChartCode == 'pipeLineNum'">
                  <h2>管网里程</h2>
                  <h3>
                    <span>{{ item.reportChartValue }}</span
                    >m
                  </h3>
                </dd>
                <dt v-if="item.reportChartCode == 'pipeWellNum'">
                  <img src="@/assets/dataV/blue/pic9.png" alt="" />
                </dt>
                <dd v-if="item.reportChartCode == 'pipeWellNum'">
                  <h2>管井</h2>
                  <h3>
                    <span>{{ item.reportChartValue }}</span
                    >个
                  </h3>
                </dd>
              </dl>
            </div>
            <div class="dataV-body-m-m">
              <mapLittle></mapLittle>
            </div>
            <div class="dataV-body-m-b">
              <div class="dataV-tit">
                <img src="@/assets/dataV/blue/tit3.png" alt="" />
              </div>
              <div class="dataV-body-m-b-box">
                <div class="dataV-body-m-b-box-l">
                  <pieChart
                    v-if="townTask.length > 0"
                    :PieData="townTask"
                  ></pieChart>
                </div>
                <div class="dataV-body-m-b-box-r">
                  <div class="dataV-body-m-b-box-r-select">
                    <el-form :inline="true" :model="form">
                      <el-row>
                        <el-col :span="12">
                          <el-form-item label="镇/街道">
                            <el-select
                              v-model="form.townCode"
                              placeholder="镇/街道"
                              @change="queryRoadByTownCode"
                            >
                              <el-option
                                v-for="item in townList"
                                :key="item.id"
                                :label="item.townName"
                                :value="item.townCode"
                              ></el-option>
                            </el-select>
                          </el-form-item>
                        </el-col>
                        <el-col :span="12">
                          <el-form-item label="路段">
                            <el-select
                              v-model="form.roadCode"
                              placeholder="路段"
                              @change="queryPipeByRoadId"
                            >
                              <el-option
                                v-for="item in roadList"
                                :key="item.id"
                                :label="item.roadName"
                                :value="item.id"
                              ></el-option>
                            </el-select>
                          </el-form-item>
                        </el-col>
                      </el-row>
                    </el-form>
                  </div>
                  <div class="dataV-body-m-b-box-r-con">
                    <dl v-for="item in roadTotalList" :key="item.id">
                      <dt
                        v-if="item.reportChartCode == 'pipeRoadLineTotalLenth'"
                      >
                        <img src="@/assets/dataV/blue/pic15.png" alt="" />
                      </dt>
                      <dd
                        v-if="item.reportChartCode == 'pipeRoadLineTotalLenth'"
                      >
                        <h2>管道总里程</h2>
                        <h3>
                          <span>{{ item.reportChartValue }}</span
                          >个
                        </h3>
                      </dd>
                      <dt v-if="item.reportChartCode == 'sewageLine'">
                        <img src="@/assets/dataV/blue/pic16.png" alt="" />
                      </dt>
                      <dd v-if="item.reportChartCode == 'sewageLine'">
                        <h2>污水管道</h2>
                        <h3>
                          <span>{{ item.reportChartValue }}</span
                          >米
                        </h3>
                      </dd>
                      <dt v-if="item.reportChartCode == 'rainLine'">
                        <img src="@/assets/dataV/blue/pic17.png" alt="" />
                      </dt>
                      <dd v-if="item.reportChartCode == 'rainLine'">
                        <h2>雨水管道</h2>
                        <h3>
                          <span>{{ item.reportChartValue }}</span
                          >米
                        </h3>
                      </dd>
                      <dt
                        v-if="item.reportChartCode == 'pipeRoadWellTotalLenth'"
                      >
                        <img src="@/assets/dataV/blue/pic18.png" alt="" />
                      </dt>
                      <dd
                        v-if="item.reportChartCode == 'pipeRoadWellTotalLenth'"
                      >
                        <h2>管井总数</h2>
                        <h3>
                          <span>{{ item.reportChartValue }}</span
                          >座
                        </h3>
                      </dd>
                      <dt v-if="item.reportChartCode == 'sewageWell'">
                        <img src="@/assets/dataV/blue/pic19.png" alt="" />
                      </dt>
                      <dd v-if="item.reportChartCode == 'sewageWell'">
                        <h2>污水井</h2>
                        <h3>
                          <span>{{ item.reportChartValue }}</span
                          >座
                        </h3>
                      </dd>
                      <dt v-if="item.reportChartCode == 'rainWell'">
                        <img src="@/assets/dataV/blue/pic20.png" alt="" />
                      </dt>
                      <dd v-if="item.reportChartCode == 'rainWell'">
                        <h2>雨水井</h2>
                        <h3>
                          <span>{{ item.reportChartValue }}</span
                          >座
                        </h3>
                      </dd>
                    </dl>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="dataV-body-r">
            <div class="dataV-tit">
              <img src="@/assets/dataV/blue/tit4.png" alt="" />
            </div>
            <div class="dataV-body-r-part1">
              <dl v-for="item in pipeTotal" :key="item.id">
                <dt v-if="item.reportChartCode == 'rainLine'">
                  <img src="@/assets/dataV/blue/pic11.png" alt="" />
                </dt>
                <dd v-if="item.reportChartCode == 'rainLine'">
                  <h2>
                    <span>{{ item.reportChartValue }}</span
                    >km
                  </h2>
                  <h3>雨水管道</h3>
                </dd>
                <dt v-if="item.reportChartCode == 'sewageLine'">
                  <img src="@/assets/dataV/blue/pic12.png" alt="" />
                </dt>
                <dd v-if="item.reportChartCode == 'sewageLine'">
                  <h2>
                    <span>{{ item.reportChartValue }}</span
                    >km
                  </h2>
                  <h3>污水管道</h3>
                </dd>
                <dt v-if="item.reportChartCode == 'rainWell'">
                  <img src="@/assets/dataV/blue/pic13.png" alt="" />
                </dt>
                <dd v-if="item.reportChartCode == 'rainWell'">
                  <h2>
                    <span>{{ item.reportChartValue }}</span
                    >座
                  </h2>
                  <h3>雨水井</h3>
                </dd>
                <dt v-if="item.reportChartCode == 'sewageWell'">
                  <img src="@/assets/dataV/blue/pic14.png" alt="" />
                </dt>
                <dd v-if="item.reportChartCode == 'sewageWell'">
                  <h2>
                    <span>{{ item.reportChartValue }}</span
                    >座
                  </h2>
                  <h3>污水井</h3>
                </dd>
              </dl>
            </div>
            <div class="dataV-tit">
              <img src="@/assets/dataV/blue/tit5.png" alt="" />
            </div>
            <div class="dataV-body-r-part2">
              <doubleBarChart
                v-if="xData.length > 0"
                :xData="xData"
                :dataL="dataL"
                :dataR="dataR"
              ></doubleBarChart>
            </div>
            <div class="dataV-tit">
              <img src="@/assets/dataV/blue/tit6.png" alt="" />
            </div>
            <div class="dataV-body-r-part3">
              <div class="dataV-body-r-part3-t">
                <div class="dataV-body-r-part3-t-t">
                  <ul>
                    <li
                      @click="tabIndex = 1"
                      :class="tabIndex == '1' ? 'active' : ''"
                    >
                      圆形
                    </li>
                    <li
                      @click="tabIndex = 2"
                      :class="tabIndex == '2' ? 'active' : ''"
                    >
                      矩形
                    </li>
                  </ul>
                </div>
                <div class="dataV-body-r-part3-t-con">
                  <scatterChart
                    v-if="scatterYData.length > 0 && tabIndex == '1'"
                    :xData="scatterXData"
                    :yData="scatterYData"
                  >
                  </scatterChart>
                  <scatterChart2
                    v-if="scatterYData2.length > 0 && tabIndex == '2'"
                    :xData="scatterXData2"
                    :yData="scatterYData2"
                  >
                  </scatterChart2>
                </div>
              </div>
              <div class="dataV-body-r-part3-b">
                <a href="https://www.azliot.com/" target="_blank">
                  <dl>
                    <dt>
                      <img src="@/assets/dataV/blue/pic21.png" alt="" />
                    </dt>
                    <dd>车辆定位调度</dd>
                  </dl>
                </a>
                <a href="https://zfy.aigo.com:7715" target="_blank">
                  <dl>
                    <dt>
                      <img src="@/assets/dataV/blue/pic22.png" alt="" />
                    </dt>
                    <dd>现场连线</dd>
                  </dl>
                </a>
                <a href="https://mg.baibutonget.com/index/spy" target="_blank">
                  <dl>
                    <dt>
                      <img src="@/assets/dataV/blue/pic23.png" alt="" />
                    </dt>
                    <dd>视频连线</dd>
                  </dl>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <el-drawer
        title="功能菜单"
        :visible.sync="drawerVisible"
        direction="ltr"
        size="300px"
        :z-index="9999"
        :modal="false"
      >
        <el-menu
          :default-active="$route.path"
          class="el-menu-vertical-demo"
          unique-opened
        >
          <template v-for="(menu, index) in menuList">
            <template>
              <el-submenu :index="menu.id + ''" :key="menu.menuId">
                <template slot="title">
                  <img class="menu-icon" :src="getImgUrl(menu.icon)" alt="" />
                  <span slot="title" style="font-size: 15px">{{
                    menu.name
                  }}</span>
                </template>
                <el-menu-item-group>
                  <div
                    v-for="(item, indexSub) in menu.childrenList"
                    @click="goToPage(item.url)"
                    :key="item.id"
                  >
                    <el-menu-item :index="menu.id + '-' + item.id">{{
                      item.name
                    }}</el-menu-item>
                  </div>
                </el-menu-item-group>
              </el-submenu>
            </template>
          </template>
        </el-menu>
      </el-drawer>
    </ScaleBox>
  </div>
</template>

<script>
import dayjs from "dayjs";
import lineChart from "./components/lineChart.vue";
import pieChart from "./components/pieChart.vue";
import doubleBarChart from "./components/doubleBarChart.vue";
import scatterChart from "./components/scatterChart.vue";
import calendarChart from "./components/calendarChart.vue";
import { mapGetters } from "vuex";
import scatterChart2 from "./components/scatterChart2.vue";

import mapLittle from "../map/mapLittle.vue";
import ScaleBox from "vue2-scale-box";
import {
  queryReport,
  queryPipeByRoadId,
  queryRoadByTownCode,
  queryTown,
} from "@/api/dataV";
export default {
  computed: {
    ...mapGetters(["userInfo"]),
  },
  components: {
    ScaleBox,
    lineChart,
    mapLittle,
    pieChart,
    doubleBarChart,
    scatterChart,
    calendarChart,
    scatterChart2,
  },
  data() {
    return {
      drawerVisible: false,
      menuList: [],
      sysdate: "",
      dateTime: "",
      projectTotal: [], //项目与任务概览
      projectRate: [], //各项目完成率排名
      projectRateColor: {
        0: ["#26E9BE", "#084643"],
        1: ["#2FD0FF", "#014047"],
        2: ["#E5C446", "#30392C"],
        3: ["#E07248", "#2E2A2B"],
      },
      taskWorkItem: [], //各类任务占比
      townTotal: [], //街道道路管井官网汇总
      pipeTotal: [], //	管网与管井汇总
      orderTime: [], //	收到工单时间点分布
      carData: [], //	本月所有车辆公里数每日汇总
      roadTotalList: [], //	各街镇数据
      roundPipeWellItem: [], //	管井圆形材质分类汇总
      rectanglePipeWellItem: [], //	管井矩形材质分类汇总
      date: new Date(),
      workXdata: [],
      workYdata: [],
      townList: [],
      roadList: [],
      townTask: [],
      xData: [],
      dataL: [],
      dataR: [],
      form: {
        townCode: "",
        roadCode: "",
      },
      tabIndex: 1,
      scatterYData: [],
      scatterXData: [],
      scatterYData2: [],
      scatterXData2: [],
    };
  },
  mounted() {
    // this.timer = setInterval(() => {
    //   const date = dayjs(new Date());
    //   this.sysdate = date.format("YYYY-MM-DD HH:mm:ss");
    // }, 1000);
    this.sysdate = dayjs(new Date()).format("YYYY-MM-DD HH:mm:ss");
    this.dateTime = dayjs(new Date()).format("YYYY-MM-DD") + " 02:00:00";
    console.log("userInfo:", this.userInfo);

    // 获取菜单列表
    if (this.userInfo) {
      this.menuList = this.userInfo.menuList;
    }
  },
  created() {
    //  this.timer = setInterval(() => {
    // this.queryReport();
    //  }, 5000);
    // this.queryTown();
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  },
  methods: {
    openDrawer() {
      this.drawerVisible = true;
    },
    goToHome() {
      this.$router.push("/home");
    },
    getImgUrl(path) {
      if (path) {
        try {
          return require('@/assets/menu/' + path + '.png');
        } catch (e) {
          return '';
        }
      }
    },
    goToPage(url) {
      if (url.length > 0) {
        if (/^(https?:|mailto:|tel:)/.test(url)) {
          window.location.href = url;
        } else {
          this.$router.push(url);
        }
      }
    },
    queryReport() {
      queryReport().then((res) => {
        if (res.data.code === 200) {
          this.projectTotal = res.data.data.projectTotal; //项目与任务概览
          this.projectRate = res.data.data.projectRate; //各项目完成率排名

          let taskWorkItemTotal = 0;
          let taskWorkItem = res.data.data.taskWorkItem; //各类任务占比
          taskWorkItem.forEach((item) => {
            taskWorkItemTotal += parseInt(item.reportChartValue);
          });

          taskWorkItem.forEach((item) => {
            item.percent = (
              (parseInt(item.reportChartValue) / taskWorkItemTotal) *
              100
            ).toFixed(2);
          });
          this.taskWorkItem = taskWorkItem;

          this.townTotal = res.data.data.townTotal; //街道道路管井官网汇总
          this.pipeTotal = res.data.data.pipeTotal; //管网与管井汇总
          this.orderTime = res.data.data.orderTime; //	收到工单时间点分布
          this.workXdata = [];
          this.workYdata = [];
          this.orderTime.forEach((item) => {
            this.workYdata.push(item.reportChartValue);
            this.workXdata.push(item.reportChartCode);
          });
          this.townTask = res.data.data.townTask; //	各街道任务占比
          this.townTask.forEach((item) => {
            item.value = item.reportChartValue;
            item.name = item.reportChartCode;
          });
          this.carData = [];
          this.carData = res.data.data.carData; //	本月所有车辆公里数每日汇总
          this.carData.forEach((item) => {
            let date = dayjs(item.reportDate);
            date.format("YYYY-MM-DD");
            item.value = [item.reportDate, parseInt(item.reportChartValue)];
          });
          let rainPipeLineItem = res.data.data.rainPipeLineItem; //	本月所有车辆公里数每日汇总
          let sewagePipeLineItem = res.data.data.sewagePipeLineItem; //	本月所有车辆公里数每日汇总
          this.xData = [];
          this.dataL = [];
          this.dataR = [];
          let otherL = 0;
          let otherR = 0;
          rainPipeLineItem.forEach((item, index) => {
            // otherL = this.$math.format(
            //   this.$math.add(
            //     this.$math.bignumber(otherL),
            //     this.$math.bignumber(item.reportChartValue)
            //   )
            // );
            // if (index < 8) {
            //   this.xData.push(item.reportChartCode);
            //   this.dataL.push(item.reportChartValue);
            // }
            // if (index == rainPipeLineItem.length - 1) {
            //   this.xData.push("其他");
            //   this.dataL.push(otherL);
            // }
            this.xData.push(item.reportChartCode);
            // this.dataL.push(item.reportChartValue)
            this.dataL.push(
              this.$math.format(
                this.$math.divide(
                  this.$math.bignumber(item.reportChartValue),
                  10000,
                ),
                { notation: "fixed", precision: 2 },
              ),
            );
          });

          sewagePipeLineItem.forEach((item, index) => {
            //   otherR = this.$math.format(
            //     this.$math.add(
            //       this.$math.bignumber(otherR),
            //       this.$math.bignumber(item.reportChartValue)
            //     )
            //   );

            // if (index < 8) {
            //   this.dataR.push(item.reportChartValue);
            // }
            // if (index == sewagePipeLineItem.length - 1) {
            //   this.dataR.push(otherR);
            // }
            // this.dataR.push(item.reportChartValue);
            this.dataR.push(
              this.$math.format(
                this.$math.divide(
                  this.$math.bignumber(item.reportChartValue),
                  10000,
                ),
                { notation: "fixed", precision: 2 },
              ),
            );
          });

          let roundPipeWellItem = res.data.data.roundPipeWellItem; //	管井圆形材质分类汇总
          let rectanglePipeWellItem = res.data.data.rectanglePipeWellItem; //	管井矩形材质分类汇总

          // 定义一个排序函数，用于比较reportChartCode
          function compareReportChartCode(a, b) {
            // 如果a或b是"小于"开头，则视为较小
            if (a.startsWith("小于")) return -1;
            if (b.startsWith("小于")) return 1;

            // 如果a或b是"大于"开头，则视为较大
            if (a.startsWith("大于")) return 1;
            if (b.startsWith("大于")) return -1;

            // 否则，尝试将a和b转换为数字进行比较
            const numA = parseInt(a, 10);
            const numB = parseInt(b, 10);
            if (!isNaN(numA) && !isNaN(numB)) {
              return numA - numB;
            }

            // 如果a或b无法转换为数字，则按字符串排序
            return a.localeCompare(b);
          }

          // 使用reduce方法按reportChartType分组，并在每个分组内部排序
          const groupedAndSorted = roundPipeWellItem.reduce((acc, curr) => {
            const { reportChartType, reportChartCode, reportChartValue } = curr;

            if (!acc[reportChartType]) {
              acc[reportChartType] = [];
            }

            // 将reportChartCode和reportChartValue作为一个对象添加到分组中
            acc[reportChartType].push({ reportChartCode, reportChartValue });

            // 对当前分组进行排序（注意：这里在添加后排序，可能不是最高效，但简单明了）
            acc[reportChartType].sort((a, b) =>
              compareReportChartCode(a.reportChartCode, b.reportChartCode),
            );

            return acc;
          }, {});

          // 将结果转换为数组形式（如果需要的话）
          const result = Object.keys(groupedAndSorted).map((type) => ({
            reportChartType: type,
            items: groupedAndSorted[type],
          }));

          const groupedAndSorted2 = rectanglePipeWellItem.reduce(
            (acc, curr) => {
              const { reportChartType, reportChartCode, reportChartValue } =
                curr;

              if (!acc[reportChartType]) {
                acc[reportChartType] = [];
              }

              // 将reportChartCode和reportChartValue作为一个对象添加到分组中
              acc[reportChartType].push({ reportChartCode, reportChartValue });

              // 对当前分组进行排序（注意：这里在添加后排序，可能不是最高效，但简单明了）
              acc[reportChartType].sort((a, b) =>
                compareReportChartCode(a.reportChartCode, b.reportChartCode),
              );

              return acc;
            },
            {},
          );

          // 将结果转换为数组形式（如果需要的话）
          const result2 = Object.keys(groupedAndSorted2).map((type) => ({
            reportChartType: type,
            items: groupedAndSorted2[type],
          }));
          this.scatterYData = [];
          this.scatterXData = [];
          this.scatterYData2 = [];
          this.scatterXData2 = [];
          result.forEach((item, index) => {
            this.scatterYData.push(item.reportChartType);

            item.items.forEach((item) => {
              if (item.reportChartCode == "小于400") {
                item.reportChartCode = 350;
              }
              if (item.reportChartCode == "大于800") {
                item.reportChartCode = 850;
              }
              this.scatterXData.push([
                parseFloat(item.reportChartCode),
                index,
                parseFloat(item.reportChartValue),
              ]);
            });
          });

          result2.forEach((item, index) => {
            this.scatterYData2.push(item.reportChartType);

            item.items.forEach((item) => {
              if (item.reportChartCode == "小于400") {
                item.reportChartCode = 350;
              }
              if (item.reportChartCode == "大于800") {
                item.reportChartCode = 850;
              }
              this.scatterXData2.push([
                parseFloat(item.reportChartCode),
                index,
                parseFloat(item.reportChartValue),
              ]);
            });
          });
        }
      });
    },
    queryTown() {
      //查询街道
      queryTown().then((res) => {
        if (res.data.code === 200) {
          this.form.townCode = res.data.data[0].townCode;

          this.townList = res.data.data;
          this.queryRoadByTownCode();
        }
      });
    },
    queryRoadByTownCode() {
      //根据道路ID查询管道管井信息
      queryRoadByTownCode({
        townCode: this.form.townCode,
      }).then((res) => {
        if (res.data.code === 200) {
          this.form.roadCode = res.data.data[0].id;
          this.roadList = res.data.data;
          this.queryPipeByRoadId();
        }
      });
    },
    queryPipeByRoadId() {
      //根据街道查询道路
      queryPipeByRoadId({
        id: this.form.roadCode,
      }).then((res) => {
        if (res.data.code === 200) {
          this.roadTotalList = res.data.data;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.dataV {
  width: 100%;
  height: 100%;

  &-main {
    width: 100%;
    height: 100%;
    margin: auto;
    background: #042132;
  }

  &-header {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 90px;
    background: url("~@/assets/dataV/blue/header-bg.png") no-repeat center
      center fixed;
    background-size: 100% 100%;
    color: #fff;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: #6ad6d8;
    line-height: 20px;
    text-align: left;
    font-style: normal;

    &-left {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      justify-content: center;
      padding-left: 20px;
    }

    &-btns {
      display: flex;
      gap: 8px;
      margin-bottom: 8px;
      position: fixed;
      top: 10px;
      left: 10px;
      z-index: 9999;

      .el-button {
        background: rgba(10, 67, 93, 0.6);
        border: 1px solid #6ad6d8;
        color: #6ad6d8;
        font-size: 12px;
        padding: 5px 12px;

        &:hover {
          background: rgba(10, 67, 93, 0.8);
          border-color: #26e9be;
          color: #26e9be;
        }
      }
    }

    &-tit {
      width: 676px;
      text-align: center;

      img {
        width: 292px;
        height: 46px;
      }
    }

    &-time-sys,
    &-time-data {
      width: 300px;
      font-size: 18px;
      height: 90px;
      display: flex;
      align-items: flex-end;
      line-height: 50px;
    }

    &-time-sys {
      text-align: right;
    }

    &-time-data {
      font-size: 18px;
      height: 90px;
    }
  }

  &-body {
    padding: 0 24px 24px 24px;
    display: flex;
    justify-content: space-between;

    &-l,
    &-r {
      width: 458px;
    }

    &-l {
      &-t {
        background: #011016;
        margin-bottom: 16px;
      }

      &-part1 {
        display: flex;
        justify-content: space-between;
        margin: 20px 0 30px 0;

        dl {
          display: flex;

          align-items: center;

          dt {
            margin-right: 6px;
          }

          dd {
            margin-right: 10px;

            h2 {
              font-family: AlibabaPuHuiTi, AlibabaPuHuiTi;
              font-weight: bold;
              font-size: 16px;
              color: #2fd0ff;
              line-height: 22px;
              text-align: left;
              font-style: normal;
            }

            h3 {
              font-family: PingFangSC, PingFang SC;
              font-weight: 400;
              font-size: 12px;
              color: #b3b9bb;
              line-height: 17px;
              text-align: left;
              font-style: normal;
            }
          }
        }
      }

      &-tit {
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        font-size: 16px;
        color: #ffffff;
        line-height: 1;
        text-align: left;
        font-style: normal;
        padding: 0 10px 10px 10px;
        position: relative;

        &::after {
          content: "";
          display: block;
          position: absolute;
          left: 0;
          bottom: 0;
          width: 100%;
          height: 2px;
          background: url("~@/assets/dataV/blue/line.png") no-repeat center
            center;
          background-size: 100% 100%;
        }
      }

      &-part2 {
        margin: 20px 0 30px 0;
        display: flex;
        justify-content: space-around;

        dl {
          text-align: center;
          margin: 0 4px;

          dt {
            border: 1px solid #525f65;
            border-radius: 50%;
            width: 60px;
            height: 60px;
            padding: 4px;
            margin: 0 auto;
          }

          dd {
            h2 {
              font-family: PingFangSC, PingFang SC;
              font-weight: 500;
              font-size: 12px;
              line-height: 17px;
              text-align: center;
              font-style: normal;
              margin: 4px 0 5px 0;
            }

            h3 {
              font-family: PingFangSC, PingFang SC;
              font-weight: 400;
              font-size: 10px;
              color: #b3b9bb;
              line-height: 14px;
              text-align: center;
              font-style: normal;
            }
          }
        }
      }

      &-part3 {
        height: 160px;
        margin: 20px 0 30px 0;
      }

      &-part4 {
        margin: 21px 0;

        .dataV-proportion {
          display: flex;
          justify-content: space-between;

          dl {
            margin: 0 2px;

            dt {
              border-radius: 6px;
              height: 36px;
              background: #e04848;
              text-align: center;
              font-family: PingFangSC, PingFang SC;
              font-weight: 600;
              font-size: 14px;
              color: #ffffff;
              line-height: 36px;
              text-align: center;
              font-style: normal;
            }

            dd {
              font-family: PingFangSC, PingFang SC;
              font-weight: 400;
              font-size: 12px;
              color: #b3b9bb;
              line-height: 17px;
              text-align: center;
              font-style: normal;
              margin-top: 3px;
            }

            &:nth-child(2) {
              dt {
                background: #e07248;
              }
            }

            &:nth-child(3) {
              dt {
                background: #e5c446;
              }
            }

            &:nth-child(4) {
              dt {
                background: #26e9be;
              }
            }

            &:nth-child(5) {
              dt {
                background: #2fd0ff;
              }
            }
          }

          &-tooltip {
            padding: 16px 0 22px 0;

            ul {
              display: flex;
              justify-content: space-around;

              li {
                font-family: PingFangSC, PingFang SC;
                font-weight: 400;
                font-size: 12px;
                color: #ffffff;
                line-height: 17px;
                text-align: left;
                font-style: normal;
                display: flex;
                align-items: center;

                i {
                  display: block;
                  width: 11px;
                  height: 11px;
                  background: #e04848;
                  border-radius: 50%;
                  margin-right: 4px;
                }

                &:nth-child(2) {
                  i {
                    background: #e07248;
                  }
                }

                &:nth-child(3) {
                  i {
                    background: #e5c446;
                  }
                }

                &:nth-child(4) {
                  i {
                    background: #26e9be;
                  }
                }

                &:nth-child(5) {
                  i {
                    background: #2fd0ff;
                  }
                }
              }
            }
          }
        }
      }

      &-b {
        // &-calendar {
        //   background: #011016;
        //   ::v-deep .el-calendar__header {
        //     display: none;
        //   }
        //   ::v-deep .el-calendar__body {
        //     padding: 0;
        //   }
        //   ::v-deep .el-calendar-table thead th {
        //     padding: 0;
        //     height: 23px;
        //     font-family: PingFangSC, PingFang SC;
        //     font-weight: 600;
        //     font-size: 12px;
        //     color: #ffffff;
        //     text-align: center;
        //     font-style: normal;
        //   }
        //   ::v-deep .el-calendar-table td {
        //     border: none;
        //     padding: 0;

        //     font-family: ArialMT;
        //     font-size: 16px;
        //     color: #74797c;
        //     text-align: center;
        //     font-style: normal;
        //   }
        //   ::v-deep .el-calendar-table .el-calendar-day {
        //     padding: 0;
        //     height: 23px;
        //     border-radius: 2px;
        //     background: #3d4045;
        //     margin: 2px;
        //   }
        // }
        &-box {
          height: 195px;
          background: rgba(1, 16, 22, 1);
        }
      }
    }

    &-m {
      &-t {
        display: flex;
        justify-content: space-between;
        margin-top: 2px;

        dl {
          display: flex;

          align-items: center;
          min-width: 180px;

          dt {
          }

          dd {
            h2 {
              font-family: PingFangSC, PingFang SC;
              font-weight: 400;
              font-size: 14px;
              color: #b3b9bb;
              line-height: 24px;
              text-align: left;
            }

            h3 {
              font-family: PingFangSC, PingFang SC;
              font-weight: 400;
              font-size: 14px;
              color: #b3b9bb;
              line-height: 24px;
              text-align: left;
              font-style: normal;
              display: flex;
              align-items: center;

              span {
                font-weight: bold;
                font-size: 20px;
                margin-right: 4px;
              }
            }
          }
        }
      }

      &-m {
        height: 610px;
        margin: 15px 0;
      }

      &-b-box {
        background: #011016;
        display: flex;
        justify-content: space-between;
        height: 220px;
        padding: 0px 25px 0 25px;
        box-sizing: border-box;

        &-l {
          width: 350px;
        }

        &-r {
          margin-top: 10px;
          width: 501px;

          &-select {
            ::v-deep .el-input__inner {
              background: none;
              border: 1px #2a75f0 solid;
              height: 30px;
              line-height: 30px;
            }

            ::v-deep .el-form-item {
              display: flex;
            }

            ::v-deep .el-form-item__label {
              font-family: PingFangSC, PingFang SC;
              font-weight: 400;
              font-size: 12px;
              color: #b3b9bb;
              font-style: normal;
            }

            ::v-deep .el-form-item__content {
              width: 70%;
            }

            ::v-deep .el-icon-arrow-up:before {
              content: "\e78f";
              color: #2a75f0;
            }
          }

          &-con {
            display: flex;
            justify-content: space-between;
            flex-wrap: wrap;

            dl {
              display: flex;

              align-items: center;
              width: 96px;
              margin: 0 65px 36px 0;

              dt {
                margin-right: 10px;
              }

              dd {
                h2 {
                  font-family: PingFangSC, PingFang SC;
                  font-weight: 400;
                  font-size: 12px;
                  color: #b3b9bb;
                  line-height: 17px;
                  text-align: left;
                  font-style: normal;
                }

                h3 {
                  font-family: PingFangSC, PingFang SC;
                  font-weight: 400;
                  font-size: 12px;
                  color: #b3b9bb;
                  line-height: 17px;
                  text-align: left;
                  font-style: normal;
                  display: flex;
                  align-items: center;

                  span {
                    font-family: AlibabaPuHuiTi, AlibabaPuHuiTi;
                    font-weight: bold;
                    font-size: 16px;
                    color: #2fd0ff;
                    line-height: 22px;
                    text-align: left;
                    font-style: normal;
                    margin-right: 4px;
                  }
                }
              }
            }
          }
        }
      }

      width: 924px;
    }

    &-r {
      &-part1 {
        display: flex;
        justify-content: space-between;
        margin-bottom: 16px;
        background: rgba(1, 16, 22, 1);
        padding: 16px 22px;

        dl {
          min-width: 70px;
          text-align: center;

          dt {
          }

          dd {
            h2 {
              font-family: PingFangSC, PingFang SC;
              font-weight: 400;
              font-size: 14px;
              color: #b3b9bb;
              line-height: 20px;
              font-style: normal;

              span {
                font-family: AlibabaPuHuiTi, AlibabaPuHuiTi;
                font-weight: bold;
                font-size: 16px;
                color: #ffffff;
                font-style: normal;
                margin-right: 4px;
              }
            }

            h3 {
              font-family: PingFangSC, PingFang SC;
              font-weight: 400;
              font-size: 12px;
              color: #b3b9bb;
              line-height: 20px;
              font-style: normal;
            }
          }
        }
      }

      &-part2 {
        background: rgba(1, 16, 22, 1);
        margin-bottom: 16px;
        height: 270px;
      }

      &-part3 {
        &-t {
          background: rgba(1, 16, 22, 1);
          margin-bottom: 16px;
          height: 270px;
          padding: 0 21px;

          &-t {
            margin-top: 9px;
            border-bottom: 1px solid rgba(134, 170, 187, 1);

            ul {
              display: flex;
              margin: 0;
              margin-bottom: -1px;
              justify-content: flex-end;

              li {
                color: rgba(179, 185, 187, 1);
                width: 48px;
                height: 22px;
                margin: 0 4px;
                border: 1px solid transparent;
                text-align: center;
                cursor: pointer;

                &.active {
                  border: 1px solid rgba(134, 170, 187, 1);
                  border-bottom-color: rgba(1, 16, 22, 1);
                }
              }
            }
          }

          &-con {
            height: 240px;
          }
        }

        &-b {
          display: flex;
          justify-content: space-between;

          dl {
            width: 142px;
            height: 122px;
            display: flex;
            align-items: center;
            justify-content: center;
            flex-direction: column;
            background: url("~@/assets/dataV/blue/part-bg.png") no-repeat center
              center;
            background-size: 100% 100%;

            dt {
            }

            dd {
              font-family: PingFangSC, PingFang SC;
              font-weight: 400;
              font-size: 16px;
              color: #ffffff;
              line-height: 22px;
              font-style: normal;
            }
          }
        }
      }
    }
  }
}

// 抽屉样式
::v-deep .el-drawer {
  background: #011016 !important;
  border-right: 1px solid #525f65;

  .el-drawer__header {
    color: #ffffff;
    border-bottom: 1px solid #525f65;
    padding: 15px 20px;
    margin-bottom: 0;

    span {
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      font-size: 16px;
    }
  }

  .el-drawer__body {
    color: #b3b9bb;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 14px;

    .el-menu {
      border: none;
      background-color: transparent;

      .el-submenu {
        .el-submenu__title {
          color: #b3b9bb;
          border-bottom: 1px solid rgba(82, 95, 101, 0.3);

          &:hover {
            background-color: rgba(47, 208, 255, 0.1);
            color: #2fd0ff;
          }
        }

        .el-menu {
          background-color: rgba(1, 16, 22, 0.8);

          .el-menu-item {
            color: #b3b9bb;

            &:hover {
              background-color: rgba(47, 208, 255, 0.1);
              color: #2fd0ff;
            }

            &.is-active {
              background-color: rgba(47, 208, 255, 0.2);
              color: #2fd0ff;
            }
          }
        }
      }
    }

    ::v-deep .el-menu-item-group__title {
      padding: 0;
    }
  }
}

.menu-icon {
  width: 18px;
  height: 18px;
  font-size: 18px;
  margin: 0 5px 0 0;
  display: inline-block;
  vertical-align: middle;
  background-color: #6ad6d8;
}
</style>
